import { cn } from "@u/cn";
import { Eyebrow } from "./Eyebrow";
import { Reveal } from "./Reveal";

interface SectionHeaderProps {
  eyebrow?: string;
  /**
   * Segundo término del eyebrow, separado por `//` en color de acento —
   * el idiom `ETIQUETA // CONTEXTO` de las piezas de redes (p. ej.
   * "Tours virtuais 360° // Portugal"). Solo con `eyebrow`.
   */
  eyebrowContext?: string;
  title: string;
  highlight?: string;
  description?: string;
  className?: string;
  /** Heading level for the title. Defaults to h2 (top-level section after the
   *  page h1); `h1` is used by PageHeader. */
  as?: "h1" | "h2" | "h3" | "h4";
  /** Scroll-reveal (fade + slide up once). Opt-in — landing surfaces only. */
  reveal?: boolean;
}

export function SectionHeader({
  eyebrow,
  eyebrowContext,
  title,
  highlight,
  description,
  className,
  as: Heading = "h2",
  reveal = false,
}: SectionHeaderProps) {
  const header = (
    <div className={cn("space-y-3", className)}>
      {eyebrow && (
        <Eyebrow>
          {eyebrow}
          {eyebrowContext && (
            <>
              <span aria-hidden className="mx-2 text-brand-secondary">
                //
              </span>
              {eyebrowContext}
            </>
          )}
        </Eyebrow>
      )}
      <Heading>
        {title}
        {highlight && (
          <>
            {" "}
            <span className="text-brand-secondary">{highlight}</span>
          </>
        )}
      </Heading>
      {description && (
        // 16px (2026-08-26): era text-sm, y como este header marca el ritmo de
        // toda superficie con secciones, no quedaba prosa a tamaño de lectura
        // en ninguna landing. La bajada de sección es copy, no metadato.
        <p className="text-base text-muted-foreground leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
  return reveal ? <Reveal>{header}</Reveal> : header;
}
